import { Injectable } from '@angular/core';

import { IMeasure } from '../models/iannotation';

@Injectable({
    providedIn: 'root',
})
export class MainMeasuresService {
    private _heartRate: IMeasure | undefined = undefined;
    get heartRate() {
        return this._heartRate;
    }

    private _PR: IMeasure | undefined = undefined;
    get PR() {
        return this._PR;
    }

    private _QRS: IMeasure | undefined = undefined;
    get QRS() {
        return this._QRS;
    }

    private _QT: IMeasure | undefined = undefined;
    get QT() {
        return this._QT;
    }

    private _QTc: IMeasure | undefined = undefined;
    get QTc() {
        return this._QTc;
    }

    private _P: IMeasure | undefined = undefined;
    get P() {
        return this._P;
    }

    private _R: IMeasure | undefined = undefined;
    get R() {
        return this._R;
    }

    private _T: IMeasure | undefined = undefined;
    get T() {
        return this._T;
    }

    public extracts(measures: IMeasure[]) {
        if (measures == null) return;

        this._heartRate = measures.find((measure) => this.checkIfMeasureNameContains(measure, 'heart rate'));
        this._PR = measures.find((measure) => this.checkIfMeasureNameContains(measure, 'pr '));
        this._QRS = measures.find(
            (measure) =>
                this.checkIfMeasureNameContains(measure, 'qrs') && this.checkIfMeasureUdmContains(measure, 'ms'),
        );
        this._QT = measures.find((measure) => this.checkIfMeasureNameContains(measure, 'qt '));
        this._QTc = measures.find((measure) => this.checkIfMeasureNameContains(measure, 'qtc'));
        this._P = measures.find(
            (measure) =>
                this.checkIfMeasureNameContains(measure, 'p ') && this.checkIfMeasureUdmContains(measure, 'deg'),
        );
        this._R = measures.find(
            (measure) =>
                this.checkIfMeasureNameContains(measure, 'qrs') && this.checkIfMeasureUdmContains(measure, 'deg'),
        );
        this._T = measures.find(
            (measure) =>
                this.checkIfMeasureNameContains(measure, 't ') && this.checkIfMeasureUdmContains(measure, 'deg'),
        );
    }

    private checkIfMeasureNameContains(measure: IMeasure, measureName: string): boolean {
        return this.getName(measure).indexOf(measureName) >= 0;
    }

    private checkIfMeasureUdmContains(measure: IMeasure, udmName: string): boolean {
        return this.getUdm(measure).indexOf(udmName) >= 0;
    }

    private getName(measure: IMeasure) {
        if (measure.name != null) return measure.name.toLowerCase();

        return '';
    }

    private getUdm(measure: IMeasure) {
        if (measure.udM != null) return measure.udM.toLowerCase();

        return '';
    }
}
